






import Vue from 'vue';
import AccountType from './AccountType';

interface Status {
  label: string,
  color?: string,
  textColor?: string,
}

export default Vue.extend({
  props: {
    value: {
      type: Number,
      required: true,
    },
  },
  computed: {
    status(): Status {
      if (AccountType.isServiceProvider(this.value)) {
        return { label: 'Service Provider', color: 'red-10' };
      }
      if (AccountType.isAgency(this.value)) {
        return { label: 'Agency', color: 'amber-10' };
      }
      if (AccountType.isClient(this.value)) {
        return { label: 'Client', color: 'light-blue-5' };
      }
      return { label: 'Unknown' };
    },
    color(): string|undefined {
      return this.status.color;
    },
    label(): string {
      return this.status.label;
    },
  },
});
